export class ProductScreenerConstants {
	public static readonly ASSET_CLASS_CODE = {
		'Cash': 43518,
		'Commodity': 43525,
		'Equity': 43511,
		'Fixed Income': 43515,
		'Allocation': 43521,
		'Real Estate': 43530
	};

	// TODO: this needs to be confirmed in the future, not sure if the data we get is exact same as keys below
	public static readonly FUND_TYPE = {
		'Mutual funds': 'mutualFunds',
		'ETFS': 'ishares',
		'Closed-end funds': 'cef'
	};
}
